import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-dialog-delete-confirmation',
    templateUrl: './dialog-delete-confirmation.component.html',
    styleUrls: ['./dialog-delete-confirmation.component.css'],
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, TranslateModule]
})
export class DialogDeleteConfirmationComponent {

  public confirmMessage: string;

  constructor(public dialogRef: MatDialogRef<DialogDeleteConfirmationComponent>) { }

  close() {
    this.dialogRef.close(false);
  }

  save() {
    this.dialogRef.close(true);
  }

}
